export default __webpack_public_path__ + "static/media/37.5664a50d.jpg";